import React from 'react';
import './styles/cta.css';

function CtaButton2() {
	return (
		<div>
			<button className="ctaButton2">Download Now</button>
		</div>
	);
}

export default CtaButton2;
